var VerticalFields = require("./VerticalFields");

module.exports = function(form, layout, scale){
  return VerticalFields({
    fields: form.Form_buildSchema(),
    errors: form.state.errors || {},
    buildInput: form.Form_buildInput,
    layout: layout,
    scale: scale
  });
};



//////////////////
// WEBPACK FOOTER
// ./~/react-loose-forms.bootstrap3/layouts/ezVerticalFields.js
// module id = 73
// module chunks = 0 1 2 3 4